export function onlyDigits(v) {
  return (v || "").toString().replace(/\D/g, "");
}

export function isValidCepDigits(digits) {
  return /^\d{8}$/.test(digits);
}

export function formatCep(digits) {
  const d = onlyDigits(digits);
  if (d.length !== 8) return digits;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}
